// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const AccordionListRoot = styled.div`
  outline: none;
  overflow: auto;
`;
